import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-del-message',
  templateUrl: './del-message.component.html',
  styleUrls: ['./del-message.component.scss']
})
export class DelMessageComponent {

  message: string = "Are you sure?"
  confirmButtonText = "Yes"
  cancelButtonText = "Cancel"
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<DelMessageComponent>, private dialog: MatDialog) {
      if(data){
    this.message = data.message || this.message;
    if (data.buttonText) {
      this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
      this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
    }
      }
  }

  onConfirmClick(selectedValue): void {
    this.dialogRef.close(selectedValue);
  }

  onClose(){
    this.dialogRef.close(false);
    // this.dialog.closeAll();
  }

}
